export default __webpack_public_path__ + "content/media/descargarevistavive.89ff8595.png";